export default "__VITE_ASSET__C32LyQ4c__"